module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user3-1334b81229a2ba20adf2302f630b1019.jpg";